module.exports = __webpack_public_path__ + "static/media/carpet_request.2e44edae.svg";